import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadProducer = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "30px",
      align: "left",
    },
    {
      title: "Ver",
      width: "50px",
      align: "center",
    },
    {
      title: "Produtor",
      align: "left",
      width: "250px",
      minWidth: "100px",
    },

    {
      title: "Função",
      align: "left",
      minWidth: "150px",
      width: "150px",
    },
    {
      title: "Tipo",
      align: "left",
      width: "100px",
    },
    {
      title: "Supervisor",
      align: "left",
      width: "180px",
      minWidth: "180px",
    },
    {
      title: "Gerente",
      align: "left",
      width: "180px",
      minWidth: "180px",
    },
    {
      title: "Filial",
      align: "left",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Saldo",
      align: "left",
      width: "100px",
      tooltip: "Saldo atual conta corrente",
    },
    {
      title: "Grupo de imp.",
      tooltip: "Grupo de imposto",
      align: "left",
      width: "140px",
    },
    {
      title: "Ativo",
      tooltip: "Corretor está ativo ?",
      align: "center",
      width: "50px",
    },
    {
      title: "Acesso Online",
      tooltip: "Produtor possui acesso online ?",
      align: "center",
      minWidth: "120px",
      width: "120px",
    },

  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
